import { useCallback, useEffect, useState } from 'react';
import { influencer } from '@round/api';

type UseInfluencerLocationsReturn = {
    locations: influencer.InfluencerLocation[];
    isLoading: boolean;
    error: string | null;
    refetch: () => Promise<void>;
};

export const useInfluencerLocations = (): UseInfluencerLocationsReturn => {
    const [locations, setLocations] = useState<influencer.InfluencerLocation[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchLocations = useCallback(async () => {
        try {
            setIsLoading(true);
            setError(null);

            const response = await influencer.getInfluencerLocations({
                type: 'country',
                ordering: 'country_name',
                page_size: 250,
            });

            if (response.status === 200) {
                setLocations(response.data.results);
            } else {
                setError('Failed to fetch locations');
            }
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to fetch locations');
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchLocations();
    }, [fetchLocations]);

    return {
        locations,
        isLoading,
        error,
        refetch: fetchLocations,
    };
};
